module.exports = __webpack_public_path__ + "static/media/Section 7-plant.e73f4527.svg";